'use client';

import { useEffect } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';
import { getPreviewMode, setPreviewMode } from '@/utils/previewMode';

type PreviewRedirectProps = {
  initialPreview: boolean;
};

/**
 * Client component that checks sessionStorage for preview mode
 * and redirects to add ?preview=true if needed
 */
export const PreviewRedirect = ({ initialPreview }: PreviewRedirectProps) => {
  const router = useRouter();
  const searchParams = useSearchParams();

  useEffect(() => {
    // If URL has preview=true, set it in sessionStorage
    if (initialPreview) {
      setPreviewMode(true);
      return;
    }

    // Check if sessionStorage has preview mode but URL doesn't
    const sessionPreview = getPreviewMode();
    if (sessionPreview && !searchParams?.has('preview')) {
      // Add preview parameter to URL
      const url = new URL(window.location.href);
      url.searchParams.set('preview', 'true');
      router.replace(url.pathname + url.search);
    }
  }, [initialPreview, searchParams, router]);

  return null;
};
